import { Component, ViewChild, TemplateRef, ElementRef, Renderer2, OnInit, OnChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { TaskActionsHistoryComponent } from '../task-actions-history/task-actions-history.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { MatTabGroup } from '@angular/material/tabs';
import { ModuletypeComponent } from 'src/app/moduletype/moduletype.component';
import { forkJoin, switchMap } from 'rxjs';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { QualityDependentsComponent } from '../quality-dependents/quality-dependents.component';

@Component({
  selector: 'app-dv',
  templateUrl: './dv.component.html',
  styleUrls: ['./dv.component.scss']
}
)
export class DvComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  isProcessing = false;
  dv: any = {};
  stageName: any;
  actionStatusOptions: any;
  instructions = "";
  buttonLabels: string[] = [];
  saveButtonForTraining: boolean = false;
  skipValidationsWhileSwitchingUser: boolean = false;
  dateCustomClasses: DatepickerDateCustomClasses[];
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  isStageUsersSkipped: boolean = false;
  taskStage: any = [];
  taskStageUsers: any = [];
  isAdditionalTabUser: boolean = false;

  dropDownForDepartment: any = [];
  dropDownForDesignation: any = [];
  dropDownForDvType: any = [];
  dropDownForRequestedAt: any = [];
  dropDownForCoreBusinessArea: any = [];
  ownerList: any = [];
  qaList: any = [];
  businessAreaList: any = [];
  reasonForDvList: any = [];
  rootCauseList: any = [];
  departmentHeadList: any = [];
  ecPerformerList: any = [];
  investigationTechniqueList: any = [];
  criticalityList: any = [];
  attachAllDocuments: boolean = false;
  departmentCodeDropdown: any = [];
  designationCodeDropdown: any = [];
  dvTypeDropdown: any = [];
  requestedAtDropdown: any = [];
  coreBusinessAreaNameDropdown: any = [];
  ownerDropdown: any = [];
  qaDropdown: any = [];
  reasonForDvDropDown: any = [];
  departmentHeadDropdown: any = [];
  rootCauseDropdown: any = [];
  investigationTechniqueDropdown: any = [];
  criticalityDropdown: any = [];
  dvSearchText: string = '';
  departmentSearchText: string = '';
  designationSearchText: string = '';
  dvTypeSearchText: string = '';
  requestedAtSearchText: string = '';
  coreBusinessSearchText: string = '';
  ownerSearchText: string = '';
  qaSearchText: string = '';
  reasonForCapaSearchText: string = '';
  departmentHeadSearchText: string = '';
  rootCauseCategorySearchText: string = '';
  pdfDetailSearchText: string = '';
  criticalitySearchText: string = ''
  investigationTechniqueSearchText: string = '';

  isRequestedAtOdd: any = null;
  isDvTypeOdd: any = null;
  isDhOdd: any = null;
  isOwnerOdd: any = null;
  isQAOdd: any = null;
  isDepartmentOdd: any = null;
  isCriticalityOdd: any = null;
  isTechniqueOdd: any = null;
  showInvestigationTab: boolean = false;

  constructor(
    readonly router: Router,
    readonly dialog: MatDialog,
    readonly message: messageService,
    readonly qualityService: qmsService,
    readonly taskActionsHistoryComponent: TaskActionsHistoryComponent,
    readonly dependencyNavigationService: DependencyNavigationService,

    private readonly elem: ElementRef,
    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.isAdditionalTabUser = this.qualityService?.userRole[0]?.qmsRoles?.includes("Additional Tab User");
    this.appService.getTaskStages(qualityService.activityId, 0).subscribe((stage: any) => {
      this.taskStage = stage;
      this.isStageUsersSkipped = !stage.length;
    })
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.initiate();
    this.dependencyNavigationService.refresh.subscribe(() => {
      if (this.qualityService.moduleName == 'DV') {
        this.initiate();
      }
    });
  }

  private initiate(): void {
    this.isProcessing = true;
    this.main();
    this.getDynamicLabel();
    this.clearDropdowns();
    this.ngOnChangesReportFooter();
    this.selectedTabIndex = 0;
  }

  clearDropdowns() {
    Object.keys(this.qualityService.dvPageAllDropdownValues).forEach(key => {
      if (key === 'coreBusinessAreaNameValue' || key === 'reasonForDeviationValue' || key === 'dvRootCauseCategory') {
        this.qualityService.dvPageAllDropdownValues[key] = [];
      } else {
        this.qualityService.dvPageAllDropdownValues[key] = null;
      }
    })
  }

  private formatDate(date?: any): string | null {
    return date ? this.appService.dateZoneConvertion(new Date(date)) : null;
  }

  private mapBooleanToYN(value?: boolean): 'Y' | 'N' {
    return value ? 'Y' : 'N';
  }

  main() {

    this.qualityService.activity = {};
    this.qualityService.activityDynamicButtonList = [];
    this.objForDocuments = { id: this.qualityService.activityId, pagename: "Activity" };

    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');

    this.dropDownForDepartment.length && this.selectBoxForDepartment();
    this.dropDownForDesignation.length && this.selectBoxForDesignation();

    const groupId = this.qualityService.selectedActivityGroupId;
    const groupDetailId = this.qualityService.selectedGroupDetailData.groupDetailId;
    const moduleName = this.qualityService.moduleName;

    const getRequestedAt$ = this.appService.getAllQmsBusinessAreas();
    const getOwner$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Owner');
    const getQa$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'QA');
    const getDepartmentHead$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Department Head');
    const getEcPerformer$ = this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Effectiveness Check Performer');
    const getReasonForDv$ = this.appService.getCodeListsByGroup("REASON_FOR_DEVIATION");
    const getDvRootCause$ = this.appService.getCodeListsByGroup("DV_ROOTCAUSE_CATEGORY");
    const getDvInvestigationTechnique$ = this.appService.getCodeListsByGroup("DV_INVESTIGATION_TECHNIQUE");
    const getDvCriticality$ = this.appService.getCodeListsByGroup("DEVIATION_CRITICALITY");
    const getParallelWorkflowList$ = this.appService.getWorkflowByRefNo(this.qualityService.activityId);
    const getTypeSettings$ = this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, groupDetailId);
    const getreportTemplateList$ = this.appService.getQmsReportTemplateDetailsByModuleAndGroupId(moduleName, groupId);
    const getReportImage$ = this.appService.getOneQmsOrganizationReportImage();
    const getReportLogo$ = this.appService.getQmsReportLogoByModuleAndGroupId("QMS", groupId);

    forkJoin([
      getRequestedAt$, getOwner$, getQa$, getDepartmentHead$, getEcPerformer$, getReasonForDv$, getDvRootCause$, getDvInvestigationTechnique$, getDvCriticality$, getParallelWorkflowList$, getTypeSettings$, getreportTemplateList$, getReportImage$, getReportLogo$
    ]).pipe(
      switchMap((
        [requestedAt, owner, qa, departmentHead, ecPerformer, reasonForDv, rootCause, investigationTechnique, criticality, parallelWorkflow, typeSettings, reportTemplate, reportImage, reportLogo]) => {

        this.businessAreaList = requestedAt;
        this.dropDownForRequestedAt = this.businessAreaList.filter((item: any) => item.module === this.qualityService.moduleName);

        this.ownerList = owner;
        /*  selectBoxForOwner function has been called after activity get call to load group owners */

        this.qaList = qa;
        this.qaList.length && this.selectBoxForQa();

        this.ecPerformerList = ecPerformer;

        this.reasonForDvList = reasonForDv;
        this.reasonForDvList.length && this.selectBoxForReasonDv();

        this.rootCauseList = rootCause;
        this.rootCauseList.length && this.selectBoxForRootCause();

        this.investigationTechniqueList = investigationTechnique;
        this.investigationTechniqueList.length && this.selectBoxForInvestigationTechnique();

        this.departmentHeadList = departmentHead;
        this.departmentHeadList.length && this.selectBoxForDepartmentHead();

        this.criticalityList = criticality;
        this.criticalityList.length && this.selectBoxForCriticality();

        this.dropDownForDvType = typeSettings;
        this.dropDownForDvType.length && this.selectBoxForDvType();

        this.parallelWorkflowList = parallelWorkflow;

        this.dropDownDataForReportTemplate = reportTemplate;
        this.selectBoxForReportTemplate();

        this.dropDownDataForReportLogo = reportLogo;

        this.organizationReportImageDetails = reportImage;
        this.selectBoxForReportLogo();

        return this.appService.getDvByDvNo(this.qualityService.activityId);
      })
    ).subscribe((crDetails: any) => {

      this.dv = crDetails;
      this.qualityService.activity = crDetails;

      this.dv.createdOn = this.dv.createdOn ? new Date(this.dv.createdOn) : null;
      this.dv.expcetedClosureOn = this.dv.expcetedClosureOn ? new Date(this.dv.expcetedClosureOn) : null;
      this.dv.expectedToBeStartedOn = this.dv.expectedToBeStartedOn ? new Date(this.dv.expectedToBeStartedOn) : null;
      this.dv.deviationOccuredOn = this.dv.deviationOccuredOn ? new Date(this.dv.deviationOccuredOn) : null;
      this.dv.deviationIdentifiedOn = this.dv.deviationIdentifiedOn ? new Date(this.dv.deviationIdentifiedOn) : null;
      this.dv.effectiveOn = this.dv.effectiveOn ? new Date(this.dv.effectiveOn) : null;
      this.dv.startedOn = this.dv.startedOn ? new Date(this.dv.startedOn) : null;
      this.dv.completedOn = this.dv.completedOn ? new Date(this.dv.completedOn) : null;
      this.dv.lastActionOn = this.dv.lastActionOn ? new Date(this.dv.lastActionOn) : null;
      this.dv.ownerAcceptanceRequestedOn = this.dv.ownerAcceptanceRequestedOn ? this.dv.ownerAcceptanceRequestedOn.split('T')[0] : null;
      this.dv.ownerApprovedOn = this.dv.ownerApprovedOn ? this.dv.ownerApprovedOn.split('T')[0] : null;

      this.message.showActionSection = this.dv.actionItemsReqd = this.dv.actionItemsReqd == "Y";
      this.message.showPreActionsTab = this.dv.preActionItemsReqd = this.dv.preActionItemsReqd == "Y";
      this.dv.effectivenessCheckReqd = this.dv.effectivenessCheckReqd == "Y";
      this.dv.isRiskCalculationReqd = this.dv.isRiskCalculationReqd == "Y";
      this.dv.investigationReqd = this.showInvestigationTab = this.dv.investigationReqd == "Y";
      this.message.showRiskTab = this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';

      this.qualityService.activity = this.dv;

      this.getStageUsers();
      this.selectBoxForRequestedAt();
      this.ownerList.length && this.selectBoxForOwner();
      this.setDropdown();
      this.getDynamicButtons();
      this.ngOnChanges();

      if (this.selectedTab != undefined && this.selectedTab == 'Investigation') this.getInvestigationTabConditions();
      this.checkDateDifference();
    });
  }

  selectBoxForDepartment() {
    this.departmentCodeDropdown = this.dropDownForDepartment?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('department-validation', item);
  }

  selectBoxForDesignation() {
    this.designationCodeDropdown = this.dropDownForDesignation?.map((designation: any) => ({
      valueExp: designation.codelistCode,
      displayExp: designation.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  selectBoxForDvType() {
    this.dvTypeDropdown = this.dropDownForDvType?.map((type: any) => ({
      valueExp: type.type,
      displayExp: type.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onDeviationTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.isTypeMandatory && this.handleDropDownValidation('deviationCriticality-validation', item);

      if (item) {
        this.isProcessing = true;

        this.appService.getTypeSettingsByType(this.qualityService.selectedActivityGroupId, this.qualityService.selectedGroupDetailId, item.valueExp).subscribe((response: any) => {
          if (response) {
            if (response?.toBeStartedInDays) {
              let date = new Date();
              date.setHours(12);
              date.setMinutes(0);
              date.setSeconds(0);
              date.setDate(date.getDate() + response.toBeStartedInDays);
              this.dv.expectedToBeStartedOn = date;
            } else {
              this.qualityService.activity.expectedToBeStartedOn = null;
            }

            if (response?.toBeClosedInDays) {
              let date = new Date();
              date.setHours(12);
              date.setMinutes(0);
              date.setSeconds(0);
              this.dv.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
              this.dv.expcetedClosureOn = date;
            } else {
              this.qualityService.activity.expcetedClosureOn = null;
            }
          }
          this.isProcessing = false;
        })
      }
    }
  }

  showChangeTypeIfNa: boolean = false;
  onDeviationCriticalitySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('deviationCriticality-validation', item);
    }
  }

  isBusinessAreaEmpty: boolean = false;
  selectBoxForRequestedAt() {
    this.requestedAtDropdown = [];
    this.requestedAtDropdown = this.dropDownForRequestedAt?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []

    const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == this.dv.requestedAt);
    this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;

    if (!this.isBusinessAreaEmpty) {
      this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
      this.selectBoxForCoreBusinessAreaName();
    }
  }

  businessAreaName: any;
  @ViewChild('flexible') flexibleComponent!: FlexibleFieldsComponent;
  @ViewChild(QualityDependentsComponent) dependentsComp!: QualityDependentsComponent;
  public openDependentsPopup(): void {
    this.dependentsComp.openPopup();
  }
  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('requestedAt-validation', item);
      if (item) {
        this.businessAreaName = item.displayExp;

        const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == item.displayExp);
        this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;
        [this.coreBusinessAreaNameDropdown, this.qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue] = [[], this.isBusinessAreaEmpty ? '' : []];

        if (!this.isBusinessAreaEmpty) {
          this.isAllBusinessAreaSelected = false;
          this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }
        setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
      }
    }
  }

  selectBoxForCoreBusinessAreaName() {
    this.coreBusinessAreaNameDropdown = [];
    this.coreBusinessAreaNameDropdown = this.dropDownForCoreBusinessArea?.map((value: any) => ({
      valueExp: value,
      displayExp: value
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('coreBusinessArea-validation', this.qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue)
        this.isAllBusinessAreaSelected = this.coreBusinessAreaNameDropdown.length == this.qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue.length;
      });
  }

  selectBoxForOwner() {
    const groupOwner = this.qualityService.selectedGroupDetailData.isGroupOwnerRequired == 'Y' || this.dv.owner == 100;
    const owners = this.ownerList?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
    const status = ['Draft', 'Department Head Requested More Info.', 'Department Head Rejected', 'Department Head Approved', 'QA Requested More Info.', 'QA Acceptance Rejected', 'Owner Requested More Info.', 'Pending Department Head Approval', 'QA Accepted', 'Pending QA Acceptance', 'Owner Acknowledgement Pending'];
    const isStatusPassed = status.includes(this.dv.status);
    setTimeout(() => { this.ownerDropdown = (groupOwner && isStatusPassed) ? [{ valueExp: 100, displayExp: 'Group Owners' }, ...owners] : owners; }, 500)
  }

  isGroupOwnerSelected: boolean = false;
  onOwnerSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('owner-validation', item);
      if (item) {
        this.isGroupOwnerSelected = item.displayExp == 'Group Owners';
      } else {
        this.isGroupOwnerSelected = false;
      }
    }
  }

  selectBoxForQa() {
    this.qaDropdown = this.qaList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onQaUserSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('qaUser-validation', item);
  }

  selectBoxForReasonDv() {
    this.reasonForDvDropDown = this.reasonForDvList?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  visibleReasonIfOthers: boolean = false;
  onReasonForDvSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reasonForDeviation-validation', item);
      if (item) {
        if (item.displayExp == 'Others') [this.visibleReasonIfOthers, this.qualityService.activity.reasonForDeviation] = [true, ''];
        else this.visibleReasonIfOthers = false;
        setTimeout(() => {
          this.isAllReasonSelected = this.reasonForDvDropDown.length == this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue.length;
        });
      }
    }
  }

  selectBoxForRootCause() {
    this.rootCauseDropdown = this.rootCauseList?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  selectBoxForInvestigationTechnique() {
    this.investigationTechniqueDropdown = this.investigationTechniqueList?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  visibleInvestigationTechniqueIfOthers: boolean;
  onDvInvestigationTechniqueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('investigationTechnique-validation', item);

      if (event.source._selected) {
        this.isProcessing = true;

        if (item.displayExp == 'Others') {
          this.visibleInvestigationTechniqueIfOthers = true;
        } else {
          this.visibleInvestigationTechniqueIfOthers = false;
          this.qualityService.activity.investigationTechniqueIfOthers = '';
        }
        this.generateQmsInvestigationTechniqueTemplateVwData();
        this.generateQmsTaskDocumentsData();
      }
    }
  }


  selectBoxForDepartmentHead() {
    this.departmentHeadDropdown = this.departmentHeadList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onDhUserSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('dhUser-validation', item);
  }

  selectBoxForCriticality() {
    this.criticalityDropdown = this.criticalityList?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onInvestigationChange(event: any) {
    if (!event.checked) {
      this.showInvestigationTab = false;
      this.qualityService.activity.investigationPlan = '';
      this.qualityService.activity.investigationDetails = '';
      this.qualityService.dvPageAllDropdownValues.investigationTechnique = null;
      this.qualityService.activity.investigationTechniqueIfOthers = '';
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    if (fieldId == 'deviationType-validation' && !this.isTypeMandatory) return;
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'business-area-validation' || fieldId === 'root-cause-type-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }


  getStageUsers() {
    const statusMap: { [key: string]: string } = {
      'Pending Review': 'Review', 'Review Inprogress': 'Review', 'Pending Approval': 'Approve', 'Approval Inprogress': 'Approve'
    };

    const stageName = statusMap[this.dv.status] || '';

    if (stageName) {
      this.appService.getTaskStageUsers(this.dv.dvNo, 0, stageName).subscribe((stageUser: any) => {
        this.taskStageUsers = stageUser.filter((user: any) => user.status && user.status != 'Review Completed' && user.status != 'Approval Completed');
        this.setAesthetic();
      });
    } else {
      this.setAesthetic();
    }
  }

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  isLoadRequiredForAdditionalDetails: boolean = false;
  setDropdown() {

    const matchingRequestedAt = this.dropDownForRequestedAt?.find((item: any) => item.taskRequestedAt === this.dv.requestedAt);
    if (!matchingRequestedAt) {
      this.isRequestedAtOdd = this.dv.requestedAt;
      this.requestedAtDropdown.push({
        valueExp: this.dv.requestedAt,
        displayExp: this.dv.requestedAt
      })
    }
    this.isLoadRequiredForAdditionalDetails = true;

    this.qualityService.dvPageAllDropdownValues.requestedAtValue = this.businessAreaName = this.dv.requestedAt;
    const selectedBusinessArea = this.isBusinessAreaEmpty ? this.dv.coreBusinessAreaName : this.dv.coreBusinessAreaName?.split(',') ?? [];
    this.qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue = selectedBusinessArea;

    setTimeout(() => {
      if (!this.isBusinessAreaEmpty) this.isAllBusinessAreaSelected = this.qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue.length == this.coreBusinessAreaNameDropdown.length;
    }, 1500);

    if (this.dv.deptCode) {
      let matchingDepartment = this.dropDownForDepartment.find((x: any) => x.codelistCode === this.dv.deptCode);
      if (matchingDepartment) {
        this.isDepartmentOdd = null;
      } else {
        this.isDepartmentOdd = this.dv.deptCode;
        this.departmentCodeDropdown.push({
          valueExp: this.dv.deptCode,
          displayExp: this.dv.deptCode
        });
      }
      this.qualityService.dvPageAllDropdownValues.departmentValue = this.dv.deptCode;
    }

    if (this.dv.departmentHead) {
      let matchingDepartmentHead = this.departmentHeadDropdown.find((x: any) => x.valueExp === this.dv.departmentHead);
      if (matchingDepartmentHead) {
        this.isDhOdd = null;
      } else {
        this.isDhOdd = this.dv.departmentHead;
        this.departmentHeadDropdown.push({
          valueExp: this.dv.departmentHead,
          displayExp: this.dv.departmentHeadUserName
        })
      }
      this.qualityService.dvPageAllDropdownValues.departmentHeadUserValue = this.dv.departmentHead;
    }

    if (this.dv.qaUser) {
      let matchingQa = this.qaDropdown.find((x: any) => x.valueExp === this.dv.qaUser);
      if (matchingQa) {
        this.isQAOdd = null;
      } else {
        setTimeout(() => { this.isOwnerOdd = this.dv.owner; }, 2000);

        this.qaDropdown.push({
          valueExp: this.dv.qaUser,
          displayExp: this.dv.qaUserName
        })
      }
      this.qualityService.dvPageAllDropdownValues.qaUserValue = this.dv.qaUser;
    }

    if (this.dv.owner || this.dv.owner == 0) {
      setTimeout(() => {
        let matchingOwner = this.ownerDropdown.find((x: any) => x.valueExp === this.dv.owner);
        if (matchingOwner) {
          this.isOwnerOdd = null;
        } else {
          this.isOwnerOdd = this.dv.owner;
          this.ownerDropdown.push({
            valueExp: this.dv.owner,
            displayExp: this.dv.ownerUserName
          })
        }
      }, 2000)
      this.qualityService.dvPageAllDropdownValues.ownerValue = this.dv.owner;
    }

    if (this.dv.deviationType) {
      this.qualityService.dvPageAllDropdownValues.deviationTypeValue = this.dv.deviationType;
      let matchingDvType = this.dvTypeDropdown.find((x: any) => x.valueExp === this.dv.deviationType);
      if (matchingDvType) {
        this.isDvTypeOdd = null;
      } else {
        this.isDvTypeOdd = this.dv.deviationType;
        this.dvTypeDropdown.push({
          valueExp: this.dv.deviationType,
          displayExp: this.dv.deviationType
        });
      }
    } else {
      this.qualityService.dvPageAllDropdownValues.deviationTypeValue = null;
    }

    if (this.dv.investigationTechnique) {
      const matchingTechnique = this.investigationTechniqueDropdown.find((x: any) => x.valueExp == this.dv.investigationTechnique);
      if (matchingTechnique) {
        this.isTechniqueOdd = null;
      } else {
        this.isTechniqueOdd = this.dv.investigationTechnique;
        this.investigationTechniqueDropdown.push({
          valueExp: this.dv.investigationTechnique,
          displayExp: this.dv.investigationTechnique
        });
      }
      this.qualityService.dvPageAllDropdownValues.investigationTechnique = this.dv.investigationTechnique;
    } else {
      this.qualityService.dvPageAllDropdownValues.investigationTechnique = null;
    }

    if (this.dv.deviationCriticality) {
      const matchingCriticality = this.criticalityDropdown.find((x: any) => x.valueExp == this.dv.deviationCriticality);
      if (!matchingCriticality) {
        this.isCriticalityOdd = this.dv.deviationCriticality;
        this.criticalityDropdown.push({
          valueExp: this.dv.deviationCriticality,
          displayExp: this.dv.deviationCriticality
        });
      }
      this.qualityService.dvPageAllDropdownValues.deviationCriticality = this.dv.deviationCriticality;
    }

    this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue = this.dv.reasonForDeviationCode?.split(',') ?? []
    this.visibleReasonIfOthers = this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue?.includes('Others');

    this.qualityService.dvPageAllDropdownValues.dvRootCauseCategory = this.dv.rootCauseCategory?.split(',') ?? [];
    this.visibleInvestigationTechniqueIfOthers = this.dv.investigationTechnique === 'Others';

    setTimeout(() => {
      this.isAllReasonSelected = this.reasonForDvDropDown.length == this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue.length;
      this.isAllRootCauseSelected = this.rootCauseDropdown.length == this.qualityService.dvPageAllDropdownValues.dvRootCauseCategory.length;
    });


  }

  private getDynamicButtons() {
    let data1 = {
      activityId: this.message.activityId,
      moduleName: this.qualityService.moduleName,
      status: this.dv.status
    }
    this.appService.getQmsButtons(data1).subscribe((data: any) => {
      this.isProcessing = false;
      this.qualityService.activityDynamicButtonList = [];
      this.buttonLabels = [];
      this.qualityService.activitySaveButton = false;
      if (data.resultType == "S") {
        this.qualityService.showflexifieldshow = false;
        this.stageName = data.stageName;
        this.actionStatusOptions = data.actionStatusOptions;
        this.instructions = data.instructions;
        this.qualityService.activityButtonLabels = data;
        if (data.buttonLabels) {
          this.buttonLabels = data.buttonLabels.split(",");
          this.buttonLabels.unshift("Cancel");
          this.qualityService.activityDynamicButtonList = this.buttonLabels;
          console.log('DYNAMIC BUTTONS LIST→ ', this.qualityService.activityDynamicButtonList);
          for (const element of this.buttonLabels) {
            if (element.includes("Submit") || element.includes("Review") || element.includes("Approve") || element.includes("Accept")) {
              this.qualityService.showflexifieldshow = true;
            }
            if (element == "Save") {
              this.qualityService.activitySaveButton = true;
            }
          }
        } else {
          this.buttonLabels.unshift("Cancel");
          this.qualityService.activityDynamicButtonList = this.buttonLabels;
        }
      } else {
        this.buttonLabels.unshift("Cancel");
        this.qualityService.activityDynamicButtonList = this.buttonLabels;
      }
      if (data.resultType != "S") {
        this.showSnackBar(data.result, data.resultType);
      }
    })
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value); searchBox?.focus();
    }, 0)
  }

  @ViewChild('reason') reason: MatSelect;
  isAllReasonSelected = false;
  @ViewChild('businessArea') businessArea: MatSelect;
  isAllBusinessAreaSelected = false;
  @ViewChild('rootCause') rootCause: MatSelect;
  isAllRootCauseSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'businessArea') {
      if (this.isAllBusinessAreaSelected) this.businessArea.options.forEach((item: MatOption) => item.select());
      else {
        this.businessArea.options.forEach((item: MatOption) => item.deselect())
        this.qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('coreBusinessArea-validation', this.qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue)
      });
    } else if (value == 'reason') {
      if (this.isAllReasonSelected) {
        this.reason.options.forEach((item: MatOption) => item.select());
        this.visibleReasonIfOthers = this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue?.includes('Others');
      }

      else {
        this.reason.options.forEach((item: MatOption) => item.deselect());
        this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue = [];
        this.visibleReasonIfOthers = false;
      }
      setTimeout(() => {
        this.handleDropDownValidation('reasonForDeviation-validation', this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue)
      });
    } else if (value == 'rootCause') {
      if (this.isAllRootCauseSelected) this.rootCause.options.forEach((item: MatOption) => item.select());
      else {
        this.reason.options.forEach((item: MatOption) => item.deselect());
        this.qualityService.dvPageAllDropdownValues.dvRootCauseCategory = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('rootCauseCategory-validation', this.qualityService.dvPageAllDropdownValues.dvRootCauseCategory)
      });
    }
  }

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('department-validation', item);
    }
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  openGroupMethod() {
    this.topNavigationComponent.opengroupPopup();
  }

  statusAppearance(status: string) {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('QA Accepted') || status.includes('Owner Acknowledged') || status.includes('Pending Closure Approval') ||
      status.includes('In Progress') || status.includes('Pending Closure Review') || status.includes('Pending QA Acceptance') ||
      status.includes('Pending Obsolete Approval')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }

  objForDocuments: any;
  ECPerformer: boolean;
  label: any = [];
  dynamicLabel: any = null;
  getDynamicLabel() {

    const data = {
      tableName: 'QMS_DV_GRID_VW',
      moduleName: 'DV',
      gridName: 'DV',
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qualityService.activityDynamicLabel = acc;
          return acc;
        }, {});
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  getAllInvestigationTemplate: any = [];
  generateQmsInvestigationTechniqueTemplateVwData() {
    this.appService.getAllInvestigationTemplate().subscribe((templateData: any) => {
      if (this.qualityService.dvPageAllDropdownValues.investigationTechnique != null) {
        templateData = templateData.filter((x: any) => x.investigationTechniqueType === this.qualityService.dvPageAllDropdownValues.investigationTechnique);
        templateData = templateData.filter((x: any) => x.isActive === 'Y');
        this.getAllInvestigationTemplate = templateData;
      }
      this.isProcessing = false;
    })
  }

  ngOnChanges() {
    this.qualityService.refereshBreadCrumb = true;
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  onStEditorChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    let isEmpty: boolean = false;
    items && (isEmpty = this.isContentEmpty(items));
    field && (field.style.color = isEmpty ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }



  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  $present_future_config = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  $past_present_config = {
    ...this.commonDateConfig,
    maxDate: new Date()
  }

  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  $identified_on_dynamic_config() {
    return {
      ...this.commonDateConfig,
      minDate: this.qualityService.activity.deviationOccuredOn ? new Date(this.qualityService.activity.deviationOccuredOn) : new Date(),
      maxDate: new Date()
    }
  }
  private toDate(value: any): Date | null {
    return value ? new Date(value) : null;
  }
  onExpectedToBeStartedOnChange() {
    const start = this.toDate(this.qualityService.activity.expectedToBeStartedOn);
    const closure = this.toDate(this.qualityService.activity.expcetedClosureOn);

    // If closure < start → reset closure field
    if (closure && start && closure < start) {
      this.qualityService.activity.expcetedClosureOn = null;
    }
  }


  $expected_closure_dynamic_config() {
    return {
      ...this.commonDateConfig,
      minDate: this.qualityService.activity.expectedToBeStartedOn ? new Date(this.qualityService.activity.expectedToBeStartedOn) : new Date()
    }
  }

  isDiffMoreThan48Hrs: boolean = false;
  markDelayLoggingAsMandatory: boolean = false;
  onDeviationIdentifiedOnChange(value: any) {
    this.checkDateDifference();
    this.onNgModelChange(value, 'deviationIdentifiedOn-validation');
    this.qualityService.activity.deviationIdentifiedOn = value;
  }

  checkDateDifference() {
    const createdOn = this.qualityService.activity.createdOn
      ? new Date(this.qualityService.activity.createdOn)
      : null;
    const deviationOn = this.qualityService.activity.deviationIdentifiedOn
      ? new Date(this.qualityService.activity.deviationIdentifiedOn)
      : null;

    // 🧩 Validate both dates
    if (!createdOn || !deviationOn || Number.isNaN(createdOn.getTime()) || Number.isNaN(deviationOn.getTime())) {
      this.isDiffMoreThan48Hrs = false;
      this.markDelayLoggingAsMandatory = false;
      return;
    }

    // ⏰ Reset time parts to midnight (ignore hours, minutes, seconds)
    const createdDateOnly = new Date(createdOn.setHours(0, 0, 0, 0));
    const deviationDateOnly = new Date(deviationOn.setHours(0, 0, 0, 0));

    // 🧮 Calculate difference in days (createdOn - deviationIdentifiedOn)
    const diffInDays = (createdDateOnly.getTime() - deviationDateOnly.getTime()) / (1000 * 60 * 60 * 24);

    // ✅ Mark true if difference is 2 or more days
    this.isDiffMoreThan48Hrs = diffInDays >= 2;
    this.markDelayLoggingAsMandatory = this.isDiffMoreThan48Hrs
  }



  config: EditorConfig = { buttons: [] };
  config1: EditorConfig = { buttons: ST_BUTTONS };
  activityData: boolean;

  onRootCauseCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('rootCauseCategory-validation', this.qualityService.dvPageAllDropdownValues.dvRootCauseCategory);
      setTimeout(() => {
        this.isAllRootCauseSelected = this.rootCauseDropdown.length == this.qualityService.dvPageAllDropdownValues.dvRootCauseCategory.length;
      });
    }
  }

  scrollToMandatoryField: any;
  scrollToMandatoriesField(value: any) {
    this.scrollToMandatoryField = document.getElementById(value) as HTMLInputElement;
    setTimeout(() => this.scrollToMandatoryField.scrollIntoView(), 0);
  }

  limitCharacters(event: Event, field: string) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    const fieldMapping: { [key: number]: string[] } = {
      1000: ['REASON_FOR_CHANGE', 'REQUESTED_AT'],
      400: ['SHORT_DESCRIPTION'],
      4000: ['TYPE_UPDATE_JUSTIFICATION']
    };

    let charLimit = 4000;
    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }
    if (textLength > charLimit) {
      this.showSnackBar(`Maximum ${charLimit} characters allowed!`, 'E');
      target.value = target.value.substring(0, charLimit);

      if (field === 'SHORT_DESCRIPTION') {

        this.qualityService.activity.shortDescription = target.value;
      }
    }
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = tempDiv.textContent ?? tempDiv.innerText ?? '';
    return textContent.trim().length === 0;
  }

  fieldValidation(elementIds?: string[]) {
    if (elementIds && elementIds.length > 0) {
      // Use the passed array of IDs
      elementIds.forEach((elementId) => {
        const element = document.getElementById(elementId) as HTMLInputElement;
        if (element) {
          element.style.color = 'red';
        }
      });
    }
  }

  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  isTypeMandatory: boolean = false;
  private markTypeAsMandatory(status: string): void {
    const statuses = new Set([
      'Draft',
      'Department Head Requested More Info.',
      'Department Head Rejected',
      'QA Requested More Info.',
      'QA Acceptance Rejected',
      'Owner Requested More Info.',
      'Pending Department Head Approval',
      'Department Head Approved',
      'QA Accepted',
      'Pending QA Acceptance',
      'Owner Acknowledgement Pending'
    ]);
    this.isTypeMandatory = !statuses.has(status)

  }
  showUpdateType: boolean = false;
  isUpdateType: boolean = false;

  private setUpdateType(status: string): void {

    const statuses = new Set([
      'Draft',
      'Department Head Requested More Info.',
      'Department Head Rejected',
      'QA Requested More Info.',
      'QA Acceptance Rejected',
      'Owner Requested More Info.',
      'Pending Department Head Approval',
      'Department Head Approved',
      'QA Accepted',
      'Pending QA Acceptance',
      'Owner Acknowledged',
      'Owner Acknowledgement Pending'
    ]);

    this.showUpdateType = !statuses.has(status);
    setTimeout(() => { this.isUpdateType = this.showUpdateType && !this.isFrozen; }, 1500);
  }


  async update(): Promise<boolean> {
    this.qualityService.validatedCapaArray = [];
    let validationPromises: any[] = [];
    console.log(this.qualityService.activity);
    if (!this.skipValidationsWhileSwitchingUser) {
      validationPromises.push(
        {
          condition: !this.qualityService.dvPageAllDropdownValues.departmentValue && this.dynamicLabel['DEPT_NAME'].isRemovable !== 'Y',
          id: 'department-validation'
        },
        {
          condition: !this.qualityService.dvPageAllDropdownValues.ownerValue,
          id: 'owner-validation'
        },
        {
          condition: !this.qualityService.dvPageAllDropdownValues.deviationTypeValue && this.isTypeMandatory,
          id: 'deviationType-validation'
        },
        {
          condition: !this.qualityService.dvPageAllDropdownValues.requestedAtValue,
          id: 'requestedAt-validation'
        },
        {
          condition: !this.qualityService.dvPageAllDropdownValues.deviationCriticality && this.dynamicLabel['DEVIATION_CRITICALITY'].isRemovable != 'Y',
          id: 'deviationCriticality-validation'
        },
        {
          condition: !this.qualityService.dvPageAllDropdownValues.coreBusinessAreaNameValue?.length,
          id: 'coreBusinessArea-validation'
        },
        {
          condition: !this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue?.length && this.dynamicLabel['REASON_FOR_DEVIATION_CODE'].isRemovable !== 'Y',
          id: 'reasonForDeviation-validation'
        },
        {
          condition: this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue.length && this.qualityService.dvPageAllDropdownValues.reasonForDeviationValue.join(',').includes('Others') && !this.qualityService.activity.reasonForDeviation, id: 'reasonForChangeIfOthers-validation'
        },
        {
          condition: !this.qualityService.activity.expcetedClosureOn,
          id: 'expectedClosureOn-validation'
        },
        {
          condition: !this.qualityService.activity.expectedToBeStartedOn && this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable !== 'Y',
          id: 'expectedToBeStartedOn-validation'
        },
        {
          condition: this.dynamicLabel?.['DEVIATION_OCCURED_ON']?.isRemovable !== 'Y' && !this.qualityService.activity.deviationOccuredOn,
          id: 'deviationOccuredOn-validation'
        },
        {
          condition: this.dynamicLabel?.['DEVIATION_IDENTIFIED_ON']?.isRemovable !== 'Y' && !this.qualityService.activity.deviationIdentifiedOn,
          id: 'deviationIdentifiedOn-validation'
        },
        {
          condition: !this.qualityService.activity.shortDescription,
          id: 'shortDescription-validation'
        },
        {
          condition: !this.qualityService.activity.dvDescription || this.isContentEmpty(this.qualityService.activity.dvDescription),
          id: 'dvDescription-validation'
        },
        {
          condition: this.dv.qaUser !== 0 && !this.qualityService.dvPageAllDropdownValues.qaUserValue,
          id: 'qaUser-validation'
        },
        {
          condition: this.dv.departmentHead !== 0 && !this.qualityService.dvPageAllDropdownValues.departmentHeadUserValue,
          id: 'departmentHeadUser-validation'
        },
        {
          condition: this.message.showCRDetailsSection && !this.qualityService.dvPageAllDropdownValues.dvRootCauseCategory?.length,
          id: 'dvRootCauseCategory-validation'
        },
        {
          condition: this.message.showCRDetailsSection && (!this.qualityService.activity.initialAssessment || this.isContentEmpty(this.qualityService.activity.initialAssessment)) && this.dynamicLabel['INITIAL_ASSESSMENT'].isRemovable !== 'Y',
          id: 'initialAssessment-validation'
        },
        {
          condition: this.message.showCRDetailsSection && (!this.qualityService.activity.impactAssessment || this.isContentEmpty(this.qualityService.activity.impactAssessment)) && this.dynamicLabel['IMPACT_ASSESSMENT'].isRemovable !== 'Y',
          id: 'impactAssessment-validation'
        },
        {
          condition: this.message.showCRDetailsSection && this.qualityService.dvPageAllDropdownValues.investigationTechnique == 'Others' && (!this.qualityService.activity.investigationTechniqueIfOthers || this.isContentEmpty(this.qualityService.activity.investigationTechniqueIfOthers)),
          id: 'investigationTechniqueIfOthers-validation'
        },
        {
          condition: (this.isDiffMoreThan48Hrs && this.dynamicLabel['JUSTIFICATION_FOR_DELAY_LOGGING'].isRemovable !== 'Y' && !this.qualityService.activity.justificationForDelayLogging),
          id: 'justificationfordv-validation'
        },
        {
          condition: this.showInvestigationTab && (!this.qualityService.activity.investigationPlan || this.isContentEmpty(this.qualityService.activity.investigationPlan)), id: 'investigationPlan-validation'
        }
      );
    }

    const invalidIds = validationPromises.filter(v => v.condition).map(v => v.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    }

    try {
      await Promise.all(validationPromises);

      const isValidDv = !invalidIds.length;
      const isValidFlexibleFields = !this.skipValidationsWhileSwitchingUser && this.flexibleComponent.mandatoryValidation();
      const isValid = isValidDv && !isValidFlexibleFields;

      if (isValid) {
        const obj = await this.prepareObj(this.qualityService.activity, this.qualityService.dvPageAllDropdownValues);
        const result = await this.execute(obj); // wait for API
        return result;
      } else {
        this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
        return false;
      }
    } catch (error) {
      console.error('Error occurred during validation:', error);
      return false;
    }
  }

  async prepareObj(dv: any, dropDown: any) {
    return {
      groupId: dv.groupId,
      dvId: dv.dvId,
      dvNo: dv.dvNo,
      initiatedBy: dropDown.initiatedBy,
      qaUser: dropDown.qaUserValue ?? 0,
      deptCode: dropDown.departmentValue ?? null,
      departmentHead: dropDown.departmentHeadUserValue ?? 0,
      owner: dropDown.ownerValue ?? null,
      requestedAt: dropDown.requestedAtValue ?? null,
      coreBusinessAreaName: this.isBusinessAreaEmpty ? dropDown.coreBusinessAreaNameValue : dropDown.coreBusinessAreaNameValue?.join(','),
      reasonForDeviation: dv.reasonForDeviation ? dv.reasonForDeviation : null,
      reasonForDeviationCode: this.reasonForDvDropDown.length ? dropDown.reasonForDeviationValue.join(',') : dropDown.reasonForDeviationValue,
      deviationType: dropDown.deviationTypeValue ?? null,
      deviationCriticality: dropDown.deviationCriticality ?? null,
      expcetedClosureOn: this.formatDate(dv.expcetedClosureOn),
      expectedToBeStartedOn: this.formatDate(dv.expectedToBeStartedOn),
      startedOn: dv.startedOn,
      completedOn: dv.completedOn ? new Date(dv.completedOn) : null,
      justificationForDelayLogging: this.isDiffMoreThan48Hrs ? (dv.justificationForDelayLogging ?? null) : '',
      deviationOccuredOn: this.formatDate(dv.deviationOccuredOn),
      deviationIdentifiedOn: this.formatDate(dv.deviationIdentifiedOn),
      /* isRepeatedDeviation : dv.isRepeatedDeviation ?"Y":"N",
      lackOfRegulatoryCompliance : dv.lackOfRegulatoryCompliance ?"Y":"N", */
      effectivenessCheckReqd: this.mapBooleanToYN(dv.effectivenessCheckReqd),
      actionItemsReqd: this.mapBooleanToYN(dv.actionItemsReqd),
      preActionItemsReqd: this.mapBooleanToYN(dv.preActionItemsReqd),
      investigationReqd: this.mapBooleanToYN(dv.investigationReqd),
      isRiskCalculationReqd: this.mapBooleanToYN(dv.isRiskCalculationReqd),
      expectedClouserFromSettings: this.mapBooleanToYN(dv.expectedClouserFromSettings),
      finalNoGenerated: this.mapBooleanToYN(dv.finalNoGenerated),
      shortDescription: dv.shortDescription,
      dvDescription: dv.dvDescription,
      scope: dv.scope,
      initialAssessment: dv.initialAssessment,
      investigationPlan: dv.investigationPlan,
      investigationDetails: dv.investigationDetails,
      investigationTechnique: dropDown.investigationTechnique ?? null,
      investigationTechniqueIfOthers: dv.investigationTechniqueIfOthers,
      rootCauseAnalysis: dv.rootCauseAnalysis,
      rootCauseCategory: dropDown.dvRootCauseCategory.length ? dropDown.dvRootCauseCategory.join(',') : null,
      conclusion: dv.conclusion,
      impactAssessment: dv.impactAssessment,
      typeUpdateJustification: dv.typeUpdateJustification
    }
  }

  execute(obj: any): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.isProcessing = true;

      this.appService.updateDv(obj).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;

          if (Response.resultType === 'S') {
            this.main();
            if (this.skipValidationsWhileSwitchingUser) {
              this.skipValidationsWhileSwitchingUser = false;
            } else if (this.flexibleComponent.flexibleFields.length) {
              this.flexibleComponent.save('activity', this.qualityService.activityId);
            }

            if (this.qualityService.isUpdatingDvThroughDynBtn) {
              this.qualityService.isUpdatingDvThroughDynBtn = false;
            } else {
              this.showSnackBar(Response.result, Response.resultType);
            }
            this.isProcessing = false;
            resolve(true);

          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
            resolve(false);
          }
        },
        error: (error: Error) => {
          this.isProcessing = false;
          console.error('Execution error:', error);
          reject(new Error('Error Occurred'));
        }
      });
    });
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  @ViewChild('taskActiosHistoryPopup', { static: true }) taskActiosHistoryPopup: TemplateRef<any>;

  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;
  visibleTaskActiosHistoryPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  taskActiosHistoryPopupConfig = {
    width: '130%',
    height: '100%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  openTopicPopup() {
    this.message.communicatingFrom = this.qualityService.moduleName;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  canceltopicPopup() {
    this.visibleTopicPopup.close();
  }

  openTaskActionsHistory() {
    this.taskActionsHistoryComponent.ngOnInit();
    this.visibleTaskActiosHistoryPopup = this.dialog.open(this.taskActiosHistoryPopup, this.taskActiosHistoryPopupConfig);
  }

  cancelTaskActiosHistoryPopup() {
    this.visibleTaskActiosHistoryPopup.close();
  }

  getInvestigationTabConditions() {
    const status = this.dv.status;

    if (this.selectedTab == 'Investigation') {
      if (this.qualityService.loggedOwner && (status == 'Owner Acknowledged' || status == 'QA Rejected' || status == 'QA Approved' || status == 'Reopened' || status == 'Revoked')) {
        this.qualityService.isInvestigationSaveButtonReq = true;
      } else if (
        this.qualityService.loggedInitiaor &&
        (
          status == 'Draft' ||
          status == 'QA Requested More Info.' ||
          status == 'QA Acceptance Rejected' ||
          status == 'Owner Requested More Info.' ||
          status == 'Pending Review' ||
          status == 'Review Rejected' ||
          status == 'Review Inprogress' ||
          status == 'Pending Approval' ||
          status == 'Approval Inprogress' ||
          status == 'Approval Rejected' ||
          status == 'Pending QA Approval' ||
          status == 'Pending Department Head Approval' ||
          status == 'Pending QA Acceptance'
        )
      ) {
        this.qualityService.isInvestigationSaveButtonReq = true;
      } else {
        this.qualityService.isInvestigationSaveButtonReq = false;
      }
    }
  }

  selectedTab: any = 'Deviation';
  selectedTabIndex: any;
  tabIndex: number = 0;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.tabIndex = $event.index;
    if (this.selectedTab == 'Investigation') {
      this.getInvestigationTabConditions();
      this.generateQmsInvestigationTechniqueTemplateVwData();
      this.generateQmsTaskDocumentsData();
    }
    this.qualityService.selectedTabName = $event.tab.textLabel;

    this.setAesthetic();
  }

  private readonly model: {
    documents: any[];
    action: any[];
    preAction: any[],
    stagesUser: any[];
    extension: any[];
    effectiveness: any[];
    dependency: any[];
    parallelWorkFlow: any[];
  } = {
      documents: [],
      action: [],
      preAction: [],
      stagesUser: [],
      extension: [],
      effectiveness: [],
      dependency: [],
      parallelWorkFlow: [],
    };

  public on_documents_emit($event: any): void {
    this.model.action = $event.action;
  }

  public on_action_emit($event: any): void {
    this.model.documents = $event.documents;
  }

  public on_preAction_emit($event: any): void {
    this.model.preAction = $event.preAction;
  }

  public on_stageUser_emit($event: any): void {
    this.model.stagesUser = $event.stages;
  }

  public on_extension_emit($event: { $extension: any[], $destroying?: boolean }): void {
    if ($event?.$destroying) {
      this.appService.getDvByDvNo(this.qualityService.activityId).subscribe((dv: any) => {
        this.dv.expcetedClosureOn = this.qualityService.activity.expcetedClosureOn = new Date(dv.expcetedClosureOn);
      })
    }

    this.model.extension = $event.$extension;
  }

  public on_effectiveness_emit($event: any): void {
    this.model.effectiveness = $event.effectiveness;
  }

  public on_dependency_emit($event: any): void {
    this.model.dependency = $event.dependency;
  }

  public on_parallelWorkFlow_emit($event: any): void {
    this.model.parallelWorkFlow = $event.parallelWorkFlow;
  }

  // Export Report
  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dropDownDataForReportTemplate: any;
  selectedReportTemplateValue: any = null;
  reportTemplateDropdown: any = [];

  //PDF report code start

  selectBoxForReportTemplate() {
    this.reportTemplateDropdown = [];
    for (const element of this.dropDownDataForReportTemplate) {
      this.reportTemplateDropdown = this.reportTemplateDropdown.concat({
        valueExp: element.qmsReportTemplateVwPk.templateId,
        displayExp: element.templateName
      });
    }
  }
  templateid: number;
  onPdfDetailValueSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.templateid = item;
      this.handleDropDownValidation('reportTemplate-validation', item);
    }
  }

  openExportPopup() {
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
  }

  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  reportTemplateFieldValidation: any;
  exportReportGenerateFuntion() {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue) {
      let data1: any = {};

      this.dv.templateId = 17337;
      let y: number = +this.message.getUserId();
      this.dv.userId = y

      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      data1 = {
        "groupId": this.qualityService.activity.groupId + "",

        "gridName": "DV",
        "templateId": this.selectedReportTemplateValue,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "attachAllDocuments": this.attachAllDocuments ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "QI_Report",
        "currentStatus": this.qualityService.activity.status,
        "groupName": thirdL[1],
        "DVid": this.message.activityId,
        "version": "0",
        "DVId": this.qualityService.activity.dvId

      }
      this.isProcessing = true;
      this.appService.genRateDVReport(data1).subscribe((response: any) => {

        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = globalThis.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const firstst = this.message.breadcrumbData.firstLevel;
        const secondnd = this.message.breadcrumbData.secondLevel;
        const thirdL = this.message.breadcrumbData.thirdLevel;
        const fourthL = this.message.breadcrumbData.fourthLevel;

        let fileName = "";
        if (firstst != null) {
          fileName = firstst + "_";
        }
        if (secondnd != null) {
          fileName = fileName + secondnd + "_";
        }
        if (thirdL != null) {
          fileName = fileName + thirdL + "_";
        }
        if (fourthL != null) {
          fileName = fileName + fourthL + "_";
        }
        console.log(Date.now())
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })
    } else {
      alert('Please enter the all mandatory fields...');
      this.reportTemplateFieldValidation.style.color = 'red';
    }
  }

  exportReportCancelPopupFuntion() {
    this.visibleExportReportPopup.close();
  }

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qualityService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qualityService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  /* Note : if userBeingSwitched param values changed then regarding names need to changed in SwitchuserComponent too */
  async openswitchuser(userBeingSwitched: any) {
    if (this.qualityService.activity.status == "In Progress" && userBeingSwitched != "Owner" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Owner") {
      this.message.switchedUser = this.qualityService.dvPageAllDropdownValues.ownerValue;
      this.message.switchUserCurrentValue = this.qualityService.dvPageAllDropdownValues.ownerValue;
      this.message.switchUserdropDownList = this.ownerDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (userBeingSwitched == "QA") {
      this.message.switchedUser = this.qualityService.dvPageAllDropdownValues.qaUserValue;
      this.message.switchUserCurrentValue = this.qualityService.dvPageAllDropdownValues.qaUserValue;
      this.message.switchUserdropDownList = this.qaDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (userBeingSwitched == "Department Head") {
      this.message.switchedUser = this.qualityService.dvPageAllDropdownValues.departmentHeadUserValue;
      this.message.switchUserCurrentValue = this.qualityService.dvPageAllDropdownValues.departmentHeadUserValue;
      this.message.switchUserdropDownList = this.departmentHeadDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    }
    this.switchuserComponent.openswitchuser(userBeingSwitched, "DV");
  };

  onChildValueEmitted() {
    if (this.message.switchuserRole == "Owner") {
      this.qualityService.dvPageAllDropdownValues.ownerValue = this.message.switchedUser;
    } else if (this.message.switchuserRole == "QA") {
      this.qualityService.dvPageAllDropdownValues.qaUserValue = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Department Head") {
      this.qualityService.dvPageAllDropdownValues.departmentHeadUserValue = this.message.switchedUser;
    }
    this.skipValidationsWhileSwitchingUser = true;
    this.switchuserComponent.saveMethod();
    this.switchuserComponent.visibleswitchUserPopup.close();
    this.switchuserComponent.visibleConfirmationPopup.close();
    this.update();
  }//PDF report code end

  getQmsTaskDocumentsVwDetails: any = [];
  generateQmsTaskDocumentsData() {
    this.appService.getQmsTaskDocumentsVwDetailsByModule(this.qualityService.moduleName, this.qualityService.activityId).subscribe((data: any) => {
      if (this.qualityService.dvPageAllDropdownValues.investigationTechnique != null) {
        this.getQmsTaskDocumentsVwDetails = data;
        this.getQmsTaskDocumentsVwDetails = this.getQmsTaskDocumentsVwDetails.filter((x: any) => x.documentType === this.qualityService.dvPageAllDropdownValues.investigationTechnique);
      }
      if (this.getQmsTaskDocumentsVwDetails.length != 0) {
        this.operationFlagForUpload = 'Edit Upload';
      }
      this.isProcessing = false;
    })
  }

  templateToUpload: File | null = null;
  templateName: any;
  templateExtention: any;
  operationFlagForUpload: any;
  uploadDocuments(e: any) {
    this.templateToUpload = e.target.files[0];
    let fileName = e.target.files[0].name.split('.');
    this.templateName = fileName[0];
    this.templateExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();

    if (this.operationFlagForUpload == 'Upload New') {
      let addDataValues = {
        operation: 'I',
        refNo: this.qualityService.activityId,
        module: this.qualityService.moduleName,
        documentType: this.qualityService.dvPageAllDropdownValues.investigationTechnique,
        documentName: this.templateName,
        documentExtn: this.templateExtention,
      };

      console.log(addDataValues);

      const qmsTaskDocumentsData = new FormData();
      qmsTaskDocumentsData.append('file', this.templateToUpload ?? '');
      const json = JSON.stringify(addDataValues);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      qmsTaskDocumentsData.append('qmsTaskDocumentsVwDto', blob);
      this.appService.createQmsTaskDocuments(qmsTaskDocumentsData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.operationFlagForUpload = 'Edit Upload';
            this.generateQmsTaskDocumentsData();
            this.isProcessing = false;
          }
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      delete this.getQmsTaskDocumentsVwDetails[0].createdOn;
      delete this.getQmsTaskDocumentsVwDetails[0].updatedOn;

      let updateDataValues = {
        operation: 'U',
        documentId: this.getQmsTaskDocumentsVwDetails[0].documentId,
        refNo: this.qualityService.activityId,
        module: this.qualityService.moduleName,
        documentType: this.qualityService.dvPageAllDropdownValues.investigationTechnique,
        documentName: this.templateName,
        documentExtn: this.templateExtention,
      };

      console.log(updateDataValues);

      const qmsTaskDocumentsData = new FormData();
      qmsTaskDocumentsData.append('file', this.templateToUpload ?? '');
      const json = JSON.stringify(updateDataValues);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      qmsTaskDocumentsData.append('qmsTaskDocumentsVwDto', blob);
      this.appService.updateQmsTaskDocuments(qmsTaskDocumentsData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.generateQmsTaskDocumentsData();
            this.isProcessing = false;
          }
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  downloadTemplates(data: any) {
    if (data.length != 0) {
      if (data[0].documentName == undefined) {
        this.operationFlagForUpload = 'Upload New';
        let contentData = "data:application/octet-stream;base64," + this.getAllInvestigationTemplate[0].template;
        let downloadLink = document.createElement("a");
        downloadLink.href = contentData;
        downloadLink.download = this.getAllInvestigationTemplate[0].templateName + "." + this.getAllInvestigationTemplate[0].templateExtn;
        downloadLink.click();
      } else {
        let contentData = "data:application/octet-stream;base64," + this.getQmsTaskDocumentsVwDetails[0].documentBlob;
        let downloadLink = document.createElement("a");
        downloadLink.href = contentData;
        downloadLink.download = this.getQmsTaskDocumentsVwDetails[0].documentName + "." + this.getQmsTaskDocumentsVwDetails[0].documentExtn;
        downloadLink.click();
      }
    }
  }


  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }
  addworkflow: boolean = false;
  parallelWorkflowList: any = [];
  async openAddWorkflow() {
    if (this.qualityService.activity.status == "In Progress" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {

      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else this.addworkflow = true;
    this.isProcessing = false;
  };
  onworkflowChildValueEmitted() {
    this.parallelWorkflowList = null;
    this.appService.getWorkflowByRefNo(this.qualityService.activityId).subscribe((data: any) => {
      this.parallelWorkflowList = data;
    });
    this.addworkflow = false;
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };


  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {
    const editorTitleMapping: Record<string, any> = {
      'Deviation Description': this.dynamicLabel?.['DV_DESCRIPTION']?.fieldName,
      'Scope': this.dynamicLabel?.['SCOPE']?.fieldName,
      'Initial Assessment': this.dynamicLabel?.['INITIAL_ASSESSMENT']?.fieldName,
      'Root Cause Analysis': this.dynamicLabel?.['ROOT_CAUSE_ANALYSIS']?.fieldName,
      'Impact Assessment': this.dynamicLabel?.['IMPACT_ASSESSMENT']?.fieldName,
      'Conclusion': this.dynamicLabel?.['CONCLUSION']?.fieldName,
      'Investigation Plan': this.dynamicLabel?.['INVESTIGATION_PLAN']?.fieldName,
      'Investigation Details': this.dynamicLabel?.['INVESTIGATION_DETAILS']?.fieldName,
      'Investigation Technique If Others': this.dynamicLabel?.['INVESTIGATION_TECHNIQUE_IF_OTHERS']?.fieldName,
      'Justification For Delay Logging': this.dynamicLabel?.['JUSTIFICATION_FOR_DELAY_LOGGING']?.fieldName,
    };


    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qualityService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qualityService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    value = value == 'Deviation Description' ? 'dv description' : value;
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag() {
    let data = {
      pageName: 'Detail',
      labelName: "Tag",
      tagRef: this.dv.dvId
    };
    this.homepagetagComponent.openpopup(data);
  }

  onTagChildValueEmitted() {
  };

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      this.handleDropDownValidation('reportLogo-validation', item);
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {

              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }

            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  navigateToRisk() {
    this.goToTabByLabel("Risk Assessment");
  };

  @ViewChild('tabsGroup', { static: false }) tabsGroup: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => { this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position; }, 0);
  }

  goToTabByLabel(label: string) {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  }

  @ViewChild(ModuletypeComponent) moduletypeComponent!: ModuletypeComponent;
  openmoduleType: boolean = true;
  moduleTypeData: any;
  value: any;
  //openpopup
  openUpdateType() {
    this.moduleTypeData = {
      dropdownList: this.dvTypeDropdown,
      moduleTypeValue: this.qualityService.dvPageAllDropdownValues.deviationTypeValue,
      expcetedClosureOn: this.qualityService.activity.expcetedClosureOn,
      expectedToBeStartedOn: this.qualityService.activity.expectedToBeStartedOn,
      moduleName: this.dynamicLabel['DEVIATION_CRITICALITY'].fieldName,
      moduleStartedOnName: this.dynamicLabel['STARTED_ON'].fieldName,
      moduleclosedOnName: this.dynamicLabel['COMPLETED_ON'].fieldName
    }
    this.openmoduleType = true;
    this.moduletypeComponent.openpopup(this.moduleTypeData);
    //
  }

  onModuleTypeEmitted($event: any) {
    this.openmoduleType = false;
    console.log($event);
    this.qualityService.dvPageAllDropdownValues.deviationTypeValue = $event.moduleType;
    this.qualityService.activity.expcetedClosureOn = $event.expcetedClosureOn;
    this.qualityService.activity.expectedToBeStartedOn = $event.expectedToBeStartedOn;
    this.qualityService.activity.typeUpdateJustification = $event.typeUpdateJustification;
    this.update();
  }

  isFrozen: boolean = false;
  showCRDetailsSection: boolean = false;
  isUsersLock: boolean = false;
  setAesthetic() {
    const loggedUserId = this.message.getUserId();
    const { initiatedBy, owner, qaUser, departmentHead, status, preActionItemsReqd, actionItemsReqd, isRiskCalculationReqd, effectivenessCheckReqd } = this.qualityService.activity;

    const isInitiator = initiatedBy == +loggedUserId!;
    const isOwner = owner == +loggedUserId!;
    const isQa = qaUser == +loggedUserId!;
    const isEcPerformer = this.message.isEcPerformer = this.ecPerformerList.find((user: any) => user.userId === +loggedUserId!);
    const isEditableByQa = this.qualityService.selectedGroupDetailData.editableByQA == 'Y';
    const isDeptHead = departmentHead == +loggedUserId!;
    const isEditableByDeptHead = this.qualityService.selectedGroupDetailData.editableByDepartmentHead == "Y";
    const isReviewer = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == +loggedUserId!);
    const isEditableByReviewer = this.qualityService.selectedGroupDetailData.editableByReviewers == "Y";
    const isApprover = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == +loggedUserId!);
    const isEditableByApprover = this.qualityService.selectedGroupDetailData.editableByApprovers == "Y";
    const isPreActions = preActionItemsReqd;
    const isActions = actionItemsReqd;
    const isRisk = isRiskCalculationReqd && this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';

    this.qualityService.elite_AccessToClosure_Reviewer_Approver = status == "In Progress" && isOwner;
    this.message.showCRDetailsSection = effectivenessCheckReqd;
    this.isUsersLock = true;

    switch (status) {
      case 'Draft':
      case 'Department Head Requested More Info.':
      case 'Department Head Rejected':
      case 'QA Requested More Info.':
      case 'QA Acceptance Rejected':
      case 'Owner Requested More Info.':
        this.draft_aesthetic(isInitiator, isPreActions, isActions, isRisk);
        break;

      case 'Pending Department Head Approval':
        this.dept_head_approval_aesthetic(isDeptHead, isEditableByDeptHead, isPreActions, isActions, isRisk);
        break;

      case 'Department Head Approved':
      case 'QA Accepted':
        this.dept_head_approved_aesthetic(isInitiator, isPreActions, isActions, isRisk);
        break;

      case 'Pending QA Acceptance':
        this.pending_qa_acceptance_aesthetic(isQa, isEditableByQa, isPreActions, isActions, isRisk);
        break;

      case 'Pending QA Approval':
        this.pending_qa_approval_aesthetic(isQa, isEditableByQa, isPreActions, isActions, isRisk);
        break;

      case 'Owner Acknowledged':
      case 'QA Rejected':
      case 'Reviewer Requested More Info.':
      case 'Review Rejected':
      case 'Approver Requested More Info.':
      case 'Approval Rejected':
      case 'Closure Reviewer Requested More Info.':
      case 'Closure Review Rejected':
      case 'Closure Approver Requested More Info.':
      case 'Closure Approval Rejected':
      case 'Revoked':
      case 'Reopened':
        this.owner_aesthetic(isOwner, isActions, isPreActions, isRisk);
        break;

      case 'QA Approved':
        this.qa_approved_aesthetic(isOwner, isActions, isPreActions, isRisk);
        break;

      case 'Pending Review':
      case 'Review Inprogress':
        this.initial_review_aesthetic(isReviewer, isEditableByReviewer, isPreActions, isActions, isRisk);
        break;

      case 'Pending Approval':
      case 'Approval Inprogress':
        this.initial_approval_aesthetic(isApprover, isEditableByApprover, isPreActions, isActions, isRisk);
        break;

      case 'In Progress':
        this.inprogress_aesthetic(isOwner, isPreActions, isActions, isRisk);
        break;

      case 'Pending Closure Review':
      case 'Closure Review Inprogress':
        this.closure_review_aesthetic(isReviewer, isPreActions, isActions, isRisk);
        break;

      case 'Pending Closure Approval':
      case 'Closure Approval Inprogress':
        this.closure_approval_aesthetic(isApprover, isPreActions, isActions, isRisk);
        break;

      case 'Pending Delete Approval':
      case 'Pending Reopen Approval':
      case 'Pending Obsolete Approval':
      case 'Pending Revoke Approval':
      case 'Obsoleted':
      case 'Closed':
        this.freeze_aesthetic_A(isOwner, isPreActions, isActions, isRisk, status);
        break;

      case 'Owner Acknowledgement Pending':
      case 'Deleted':
        this.freeze_aesthetic_B(isPreActions, isActions, isRisk);
        break;

    }

    if (this.dv.status === 'Closed') {
      this.appService.getQmsTasksEC(this.qualityService.activityId).subscribe((data: any) => {
        this.message.showEffectiveSection = (data.length > 0) || this.qualityService.activity.effectivenessCheckReqd;
        this.message.showEffectiveActionButtons = isEcPerformer || isOwner;
      })
    } else {
      this.message.showEffectiveSection = false;
    }
    setTimeout(() => { this.setUpdateType(status) }, 1500);
    this.markTypeAsMandatory(status);
    setTimeout(() => { this.flexibleComponent.main() });
  }

  setSwitchUserAesthetic(status: any, user: string): boolean {

    if (user == "owner") {
      this.qualityService.validSwitchStatus = status != 'Deleted' && status != 'Obsoleted';
      return this.qualityService.validSwitchStatus;
    } else {
      this.qualityService.validSwitchStatus = status != 'Deleted' && status != 'Obsoleted' && status != 'Closed'
      return this.qualityService.validSwitchStatus;
    };
  }

  draft_aesthetic(isInitiator: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = this.isUsersLock = !isInitiator;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isInitiator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isInitiator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInitiator;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isInitiator;
  }

  dept_head_approval_aesthetic(isDeptHead: boolean, isEditableByDeptHead: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isDeptHead && isEditableByDeptHead);
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isDeptHead && isEditableByDeptHead;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isDeptHead && isEditableByDeptHead;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isDeptHead;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isDeptHead && isEditableByDeptHead;
  }

  dept_head_approved_aesthetic(isInitiator: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInitiator;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  pending_qa_acceptance_aesthetic(isQa: boolean, isEditableByQa: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isQa && isEditableByQa);
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isQa && isEditableByQa;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isQa && isEditableByQa;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQa;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isQa && isEditableByQa;
  }

  owner_aesthetic(isOwner: boolean, isActions: boolean, isPreActions: boolean, isRisk: boolean) {
    this.isFrozen = !isOwner;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isOwner;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isOwner;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isOwner;
  }

  pending_qa_approval_aesthetic(isQa: boolean, isEditableByQa: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isQa && isEditableByQa);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isQa && isEditableByQa;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isQa && isEditableByQa;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQa;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isQa && isEditableByQa;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isQa && isEditableByQa;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isQa && isEditableByQa;
  }

  qa_approved_aesthetic(isOwner: boolean, isActions: boolean, isPreActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isPreActions;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  initial_review_aesthetic(isReviewer: boolean, isEditableByReviewer: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isReviewer && isEditableByReviewer);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isReviewer && isEditableByReviewer;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isReviewer && isEditableByReviewer;
  }

  initial_approval_aesthetic(isApprover: boolean, isEditableByApprover: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = !(isApprover && isEditableByApprover);
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isApprover && isEditableByApprover;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = isApprover && isEditableByApprover;
  }

  inprogress_aesthetic(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false; /* Locked in Stage Users Component */
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  closure_review_aesthetic(isReviewer: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  closure_approval_aesthetic(isApprover: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  freeze_aesthetic_A(isOwner: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean, status: string) {
    let grantFileAccess: boolean = false;

    if (status == 'Pending Delete Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Delete Approver")
    } else if (status == 'Pending Revoke Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Revoke Approver")
    } else if (status == 'Pending Obsolete Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Obsolete Approver")
    } else if (status == 'Pending Reopen Approval') {
      grantFileAccess = this.qualityService?.userRole[0]?.qmsRoles?.includes("Reopen Approver")
    } else if (status == 'Closed') {
      grantFileAccess = isOwner
    }

    this.isFrozen = true;
    this.message.showCRDetailsSection = status != 'Pending Delete Approval';
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = grantFileAccess;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }

  freeze_aesthetic_B(isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.isFrozen = true;
    this.message.showCRDetailsSection = false;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = false;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qualityService.showRiskButtons = false;
  }
  reportFooterFieldValidation: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;

        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qualityService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }
}
